import {Grid, Skeleton} from '@mui/material';
import Tab from './Tab';

const Header = () => (
  <Grid
    item
    xs={12}
    sx={{
      mt: '25px',
      px: '18px',
      display: 'flex',
      justifyContent: 'space-between',
    }}>
    <Skeleton
      animation='wave'
      variant='rectangular'
      width={40}
      height={40}
      sx={{borderRadius: '98px', bgcolor: '#DFDFDF'}}
    />
    <Skeleton
      animation='wave'
      variant='rectangular'
      width={'65%'}
      height={41}
      sx={{borderRadius: '98px', bgcolor: '#DFDFDF'}}
    />
    <Skeleton
      animation='wave'
      variant='rectangular'
      width={40}
      height={40}
      sx={{borderRadius: '98px', bgcolor: '#DFDFDF'}}
    />
  </Grid>
);

const Selection = () => (
  <Grid
    item
    xs={12}
    sx={{
      mt: 4,
      mb: 5.2,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    }}>
    <Skeleton
      animation='wave'
      variant='rectangular'
      width={140}
      height={35}
      sx={{borderRadius: '98px', mr: '10px'}}
    />
    <Skeleton
      animation='wave'
      variant='rectangular'
      width={170}
      height={20}
      sx={{borderRadius: '98px', bgcolor: '#DFDFDF'}}
    />
  </Grid>
);

export const SMBGLoading = () => (
  <Grid
    container
    sx={{
      alignItems: 'flex-start',
      bgcolor: '#EEEEEE',
      width: '100%',
      height: '290px',
      borderRadius: '16px',
      mt: '1rem',
      mb: '1.2rem',
    }}>
    <Grid item xs={12} display='flex'>
      <Skeleton
        animation='wave'
        variant='rectangular'
        width={24}
        height={24}
        sx={{
          borderRadius: '4px',
          marginX: '0',
          mt: '1.7rem',
          mr: 2,
          position: 'absolute',
          bgcolor: '#DFDFDF',
        }}
      />
      <Skeleton
        animation='wave'
        variant='rectangular'
        width={170}
        height={30}
        sx={{
          borderRadius: '98px',
          marginX: 'auto',
          mt: '1.5rem',
          bgcolor: '#DFDFDF',
        }}
      />
    </Grid>
    <Grid item xs={12}>
      {[...Array(4)].map((_) => (
        <div
          style={{
            marginBottom: '25px',
            display: 'grid',
            placeItems: 'center',
          }}>
          <Skeleton
            animation='wave'
            variant='rectangular'
            width={'90%'}
            height={20}
            sx={{borderRadius: '98px', bgcolor: '#DFDFDF'}}
          />
        </div>
      ))}
    </Grid>
  </Grid>
);

export const PieLoading = () => {
  return (
    <div style={{width: '100%'}}>
      <Grid item xs={12} display='flex'>
        <Skeleton
          animation='wave'
          variant='rectangular'
          width={24}
          height={24}
          sx={{
            borderRadius: '4px',
            marginX: '0',
            mt: '1.7rem',
            mr: 2,
            position: 'absolute',
            bgcolor: '#DFDFDF',
          }}
        />
        <Skeleton
          animation='wave'
          variant='rectangular'
          width={170}
          height={30}
          sx={{
            borderRadius: '98px',
            marginX: 'auto',
            mt: '1.5rem',
            bgcolor: '#DFDFDF',
          }}
        />
      </Grid>
      <div
        style={{
          position: 'relative',
          display: 'grid',
          placeItems: 'center',
          width: '100%',
        }}>
        <Skeleton
          animation='wave'
          variant='circular'
          width={140}
          height={140}
          sx={{
            bgcolor: '#EEEEEE',
            borderRadius: '50%',
            marginX: 'auto',
            mt: '2rem',
            position: 'relative',
            borderWidth: '50px',
            borderColor: '#DFDFDF',
            borderStyle: 'solid',
          }}
        />
        <Skeleton
          animation='wave'
          variant='circular'
          width={'90%'}
          height={30}
          sx={{
            backgroundColor: '#DFDFDF',
            borderRadius: '98px',
            margin: '2rem auto 0',
          }}
        />
      </div>
    </div>
  );
};

export const BarchartLoading = () => (
  <Grid container>
    <div
      style={{
        padding: '10px',
        width: '90%',
        border: '1px solid #DFDFDF',
        flexDirection: 'row-reverse',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderRadius: '98px',
        margin: '70px auto 12px',
      }}>
      <Grid item xs={3}>
        <Skeleton
          animation='wave'
          variant='circular'
          width={52}
          height={20}
          sx={{
            borderRadius: '98px',
            marginX: 'auto',
            position: 'relative',
            bgcolor: '#DFDFDF',
          }}
        />
      </Grid>
      <Grid item placeItems='center' xs={5}>
        <Skeleton
          animation='wave'
          variant='circular'
          width={80}
          height={20}
          sx={{
            borderRadius: '98px',
            margin: 'auto',
            bgcolor: '#DFDFDF',
          }}
        />
      </Grid>
      <Grid item xs={4}>
        <div style={{display: 'flex'}}>
          <Skeleton
            animation='wave'
            variant='circular'
            width={60}
            height={20}
            sx={{
              borderRadius: '98px',
              bgcolor: '#DFDFDF',
              ml: 1,
            }}
          />
          <Skeleton
            animation='wave'
            variant='circular'
            width={60}
            height={20}
            sx={{
              borderRadius: '98px',
              bgcolor: '#DFDFDF',
            }}
          />
        </div>
      </Grid>
    </div>
    <Grid item xs={12}>
      {[...Array(10)].map((_) => (
        <div
          style={{
            marginBottom: '10px',
            display: 'grid',
            placeItems: 'center',
          }}>
          <Skeleton
            animation='wave'
            variant='rectangular'
            width={'90%'}
            height={40}
            sx={{borderRadius: '98px', bgcolor: '#DFDFDF'}}
          />
        </div>
      ))}
      <Skeleton
        animation='wave'
        variant='rectangular'
        width={120}
        height={30}
        sx={{
          borderRadius: '98px',
          margin: '3rem auto 2rem',
          bgcolor: '#DFDFDF',
        }}
      />
    </Grid>
  </Grid>
);

export const LastItemsLoading = () =>
  [...Array(3)].map((_, index) => (
    <Grid
      key={index}
      item
      xs={12}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        mt: index === 0 && 2.5,
        bgcolor: '#EEEEEE',
        height: '60px',
        borderRadius: '16px',
        mb: 2,
      }}>
      <Skeleton
        animation='wave'
        variant='rectangular'
        width={140}
        height={30}
        sx={{borderRadius: '98px', bgcolor: '#DFDFDF'}}
      />
      <Skeleton
        animation='wave'
        variant='rectangular'
        width={24}
        height={24}
        sx={{
          borderRadius: '4px',
          mr: 2,
          position: 'absolute',
          right: '10px',
          bgcolor: '#DFDFDF',
        }}
      />
    </Grid>
  ));

const Loading = () => {
  return (
    <Grid container>
      <Header />
      <Grid item xs={12} mt={2}>
        <Tab activeTab={1} showSkeleton />
      </Grid>
      <Grid
        item
        xs={12}
        sx={{
          px: '16px',
          background:
            'linear-gradient(184deg, #FFFFFF, #F5F5F5 42.19%, #F5F5F5 100%)',
        }}>
        <Selection />
        <SMBGLoading />
        <Grid
          container
          sx={{
            alignItems: 'flex-start',
            bgcolor: '#EEEEEE',
            borderRadius: '16px',
          }}>
          <PieLoading />
          <BarchartLoading />
        </Grid>
        <LastItemsLoading />
      </Grid>
    </Grid>
  );
};

export default Loading;
